// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
//import VideoPlayer from 'react-video-markers';
import './style.css';
// import { millisToSeconds } from 'utils/Helper';
import { isIOS, isSafari } from "react-device-detect";
//import useMediaQuery from '@material-ui/core/useMediaQuery';
//import { MediaQuery } from 'react-responsive';
//import { useMediaQuery } from 'react-responsive'

//import './fluidplayer.min.css';

import { motion } from "framer-motion";

import laugh_emoji from 'Assets/laugh_emoji.png';
import clapping_hands from 'Assets/clapping_hands.png';
import agree from 'Assets/agree.png';
import gold_star from 'Assets/gold_star.png';



//import fluidPlayer from "./fluid-player-master/fluidplayer.js";

//import ReactPlayer from 'react-player'

//import vtt from 'Assets/fluid_test/valerian-thumbnails.vtt';

/*
class FluidPlayer extends React.Component {
  constructor(props) {
    super(props);
  }
  
  componentDidMount() {
    this.myFluidPlayer = window.fluidPlayer(
      'my-video',
      this.props.fluid_controls
    );
  }

  componentWillUnmount() {
    this.myFluidPlayer.destroy();
  }

  render() {
    return <div id='my-video'/>;
  }
}
*/

class PlayerVideo extends Component {
  
  markers = [];

  constructor(props) {
    console.log("videoplayer constructor");
    super(props);
    this.state = {
      //presentation_reactions: {...props.presentation_reactions}, // because componentDidUpdate is dumb and does not see prevProps changing
      reactions: [],
      reactions_times: [],
      fluid_controls: null,
      cc_vtt_local_file_url: null,
      //url: props.presentation_data.presentation_video_url,
      //prev_url: props.presentation_data.presentation_video_url, // to detect when new presentation prop comes in
      //poster_url: props.presentation_data.image_url,
      controls: [
        'play',
        'progress',
        'volume',
        'full-screen'
      ],
      isPlaying: false,
      volume: 1.0,
      timeStart: 0.1,
      videoDuration: 0,
      startMuted: false,
      maxWidth1199: window.matchMedia("(max-width: 1199px)").matches,
      maxWidth991: window.matchMedia("(max-width: 991px)").matches,
      maxWidth767: window.matchMedia("(max-width: 767px)").matches,
      maxWidth575: window.matchMedia("(max-width: 575px)").matches,
      maxWidth400: window.matchMedia("(max-width: 400px)").matches
    }
    
    //this.state = { matches: window.matchMedia("(min-width: 768px)").matches };
    
    /*
    let audioDelayTimeConv;    
    if(parseInt(millisToSeconds(props.presentation_data.audio_delay))){
      audioDelayTimeConv = parseInt(millisToSeconds(props.presentation_data.audio_delay));
    }
    else
    {
      audioDelayTimeConv = null
    }
    
    let marker_obj_intro = {
      id: 0,
      time: audioDelayTimeConv,
      color: '#ffc837',
      title: 'Marker 1',
    };
    
    this.markers.push(marker_obj_intro);
    
    let slide_count = 20;
    if (props.presentation_data.slide_count) {
      slide_count = props.presentation_data.slide_count;
    }
    
    let slide_length = 20;
    if (props.presentation_data.slide_length) {
      slide_length = props.presentation_data.slide_length;
    }

    for (let i = 1; i <= slide_count; i++) {
      let marker_obj = {
        id: i,
        time: audioDelayTimeConv + (i*slide_length),
        color: '#ffc837',
        title: 'Marker '+i
      };
      this.markers.push(marker_obj);
    }
    */
    
    this.video_ref = React.createRef();
    
    this.unixtime_now = Math.round(new Date().getTime()/1000);
    
    this.check_reactions_interval = setInterval(() => this.checkReactions(), 1000); // 1s
    
    this.relay_video_time_interval = setInterval(() => {
      if (!this.video_ref.current || this.video_ref.current.paused) {
        return;
      }
      //let floor_currentTime = Math.floor(this.video_ref.current.currentTime);
      
      if (this.props.onUpdateVideoTime) {
        //this.props.onUpdateVideoTime(floor_currentTime);
        this.props.onUpdateVideoTime(this.video_ref.current.currentTime);
      }
      
    },100);
    
    //this.myFluidPlayer = null;
    
    this.reactions_assets = {
      'laugh': laugh_emoji,
      'clap': clapping_hands,
      'agree': agree,
    }
    
    this.reaction_animation_count = 7; // really 10, but 3 are reserved for self reactions
    
    this.instant_reaction = null;
    
    this.preloaded_user_avatar_image = new window.Image();
    
    this.fluid_initialize_timeout = 0;
  }



  //let url = props.presentation_data.presentation_video_url;
  
  //const [url] = useState(props.presentation_data.presentation_video_url);
  //console.log("VideoPlayer1",props.presentation_data.presentation_video_url,url);
  //setUrl(props.presentation_data.presentation_video_url);
  //console.log("VideoPlayer2",props.presentation_data.presentation_video_url,url);
  /*
  let controls = [
    'play',
    'progress',
    'volume',
    'full-screen'
  ];
  */
  
  /*
  const [controls] = useState([
    'play',
    'progress',
    'volume',
    'full-screen',
  ]);
  */
  
  //let isPlaying = true;
  //let volume = 0.7;
  //let timeStart = 0.1;
  //let videoDuration = 0;
  
  //const [isPlaying, setIsPlaying] = useState(true);
  //const [volume, setVolume] = useState(0.7);
  //const [timeStart] = useState(0.1);
  //const [videoDuration,setVideoDuration] = useState(0);

  handlePlay = () => {
    //console.log("VideoPlayer handlePlay");
    this.setState({isPlaying:true});
    //setIsPlaying(true);
  };

  handlePause = () => {
    //console.log("VideoPlayer handlePause");
    this.setState({isPlaying:false});
    //setIsPlaying(false);
  };

  handleVolume = value => {
    this.setState({volume:value});
    //setVolume(value);
  };

  handleDuration = duration => {
    //console.log("VideoPlayer handleDuration",duration);
    this.setState({videoDuration:duration});
    //setVideoDuration(duration)
  };

  handleProgress = e => {
    if(this.props.onClickVideoPlayComplete !== undefined) {
      if (parseInt(e.target.currentTime) === parseInt(e.target.duration)) {
        this.props.onClickVideoPlayComplete(true);
      } else {
        this.props.onClickVideoPlayComplete(false);
      }
      //return parseInt(e.target.currentTime) === parseInt(e.target.duration) ? this.props.onClickVideoPlayComplete(true) : this.props.onClickVideoPlayComplete(false);
    }
  };

  componentWillMount = async function () {
    //console.log("WILL MOUNT");
    //console.log("videoplayer componentWillMount",JSON.stringify(this.props,null,2));
    if (isIOS || isSafari) {
      console.log("iOS / Safari detected!");
      this.setState({startMuted: true});
    } else {
      //this.setState({startMuted: false});
      this.setState({startMuted: false});
    }
  }

  /*
  getSnapshotBeforeUpdate(prevProps, prevState) {
    console.log("VideoPlayer getSnapshotBeforeUpdate");
    console.log(JSON.stringify(prevProps.presentation_reactions));
    
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    console.log("VideoPlayer getDerivedStateFromProps");
    console.log(JSON.stringify(nextProps.presentation_reactions));
    //console.log(JSON.stringify(this.props.presentation_reactions));
    
  }
  */

  componentDidUpdate (prevProps) {
    console.log("VideoPlayer componentDidUpdate");
    //console.log(JSON.stringify(prevProps.presentation_reactions));
    //console.log(JSON.stringify(this.props.presentation_reactions));
    if (prevProps.presentation_data.presentation_video_url !== this.props.presentation_data.presentation_video_url) {
      console.log(" New Video URL!");
      if (this.props.autoPlayStatus === true) {
        this.setState({
          isPlaying: true,
          //prev_url: this.props.presentation_data.presentation_video_url
        });
      } else {
        //this.setState({
          //prev_url: this.props.presentation_data.presentation_video_url
        //});
      }
    }
    
    // did we just get a reaction?
    //this.checkReactions();

    
    if ((prevProps.instant_reaction !== this.props.instant_reaction) && this.video_ref.current) {
      //let floor_currentTime = this.video_ref.current.currentTime;
      console.log(" New reaction!",this.props.instant_reaction);
      let [reaction_type,reaction_time_raw] = this.props.instant_reaction.split('.');
      let floor_reaction_time = Math.floor(reaction_time_raw);
      this.showReactions(
        {
          [reaction_type]: {
            [floor_reaction_time]: 1
          }
        },
        floor_reaction_time,
        true
      );
    }
    
    if ((prevProps.seek_to_time !== this.props.seek_to_time) && this.myFluidPlayer) {
        console.log("seek_to_time",this.props.seek_to_time);
        this.myFluidPlayer.skipTo(this.props.seek_to_time);
        this.myFluidPlayer.play();
    }
    

    /*
    if (prevProps.presentation_reactions !== this.props.presentation_reactions) {
      console.log(" New reaction!");
      clearInterval(this.check_reactions_interval);
      this.checkReactions();
      this.check_reactions_interval = setInterval(() => this.checkReactions(), 1000); // 1s
    }
    */
    
  }

  componentWillUnmount () {
    console.log("VideoPlayer componentWillUnmount");
    clearInterval(this.check_reactions_interval);
    //ReactDOM.unmountComponentAtNode(document.getElementById('my-video'));
    if (this.myFluidPlayer) {
      this.myFluidPlayer.destroy();
      console.log("destroyed");
      //window.myFluidPlayer = null;
    }
    //if (window.fluidPlayer) {
      //window.fluidPlayer = null;
    //}
  }

  componentDidMount = async function () {
    console.log("VideoPlayer componentDidMount",this.props.autoPlayStatus);
    //this.props.autoPlayStatus==="false" ? this.setState({isPlaying:false}) : this.setState({isPlaying:true});
    //if (this.props.autoPlayStatus === false) {
    //  this.setState({isPlaying: false});
    //} else {
    //  this.setState({isPlaying: true});
    //}
    
    const handler1199 = e => this.setState({ maxWidth1199: e.matches});
    const handler991 = e => this.setState({ maxWidth991: e.matches});
    const handler767 = e => this.setState({ maxWidth767: e.matches});
    const handler575 = e => this.setState({ maxWidth575: e.matches});
    const handler400 = e => this.setState({ maxWidth400: e.matches});
    window.matchMedia("(max-width: 1199px)").addListener(handler1199);
    window.matchMedia("(max-width: 991px)").addListener(handler991);
    window.matchMedia("(max-width: 767px)").addListener(handler767);
    window.matchMedia("(max-width: 575px)").addListener(handler575);
    window.matchMedia("(max-width: 400px)").addListener(handler400);

    //let vtt_blob = await this.getRemoteVttBlob('https://stagingpkassets.pechakucha.com/tmp/valerian-thumbnails.vtt');

    let fluid_controls = {
      debug: true,
      layoutControls: {
        fillToContainer: true,
        subtitlesEnabled: true,
    		controlBar: {
    			autoHide: false,
    			autoHideTimeout: 3,
    			animated: true
    		},
        allowTheatre: false,
        primaryColor: "#E50114",
        fillToControls: true,
        posterImage: this.props.presentation_data.image_url,
        autoPlay: this.props.autoPlayStatus || false,
        playerInitCallback: (function() { console.log('*** fluid player loaded!') })
      }
    }

    //console.log("YO",this.props.presentation_data.presentation_video_seek_thumbnails_vtt_url);
    if (this.props.presentation_data.presentation_video_seek_thumbnails_vtt_url) {
      let vtt_blob = await this.getRemoteVttBlob(this.props.presentation_data.presentation_video_seek_thumbnails_vtt_url);
      let vtt_local_file_url = window.URL.createObjectURL(vtt_blob);
      fluid_controls.layoutControls.timelinePreview = {
        file: vtt_local_file_url,
        type: 'VTT'
      }
    }
    
    //this.setState({
    //  fluid_controls
    //})
    
    //console.log("YO2",fluid_controls);
    //let self = this;
    
    let fluid_player_name = 'my-video'+this.props.presentation_data.entity_uuid+(this.unixtime_now+Math.floor(Math.random() * 10000));
    
    if (window.fluidPlayer) {
      this.fluid_initialize(fluid_controls);
      /*
      this.myFluidPlayer = window.fluidPlayer(
        //fluid_player_name,
        'my-video'+this.props.presentation_data.entity_uuid+this.unixtime_now,
        //'my-video',
        fluid_controls
      );
      this.myFluidPlayer.on('pause', () => this.fluidPaused());
      */
    } else {
      setTimeout(() => {
        this.fluid_initialize(fluid_controls);
      }, this.fluid_initialize_timeout);
    }
    
    // preload user_avatar_image_url
    this.preloaded_user_avatar_image.src = this.props.user_avatar_image_url;
  }
  
  fluid_initialize = (fluid_controls) => {
    if (window.fluidPlayer) {
      this.myFluidPlayer = window.fluidPlayer(
        //fluid_player_name,
        'my-video'+this.props.presentation_data.entity_uuid+this.unixtime_now,
        //'my-video',
        fluid_controls
      );
      this.myFluidPlayer.on('pause', () => this.fluidPaused());
    } else if (this.fluid_initialize_timeout <= 3000) {
      this.fluid_initialize_timeout += 500;
      setTimeout(() => {
        this.fluid_initialize(fluid_controls);
      }, this.fluid_initialize_timeout);
    }
  }

  showReactions = (tmp_presentation_reactions,floor_currentTime,instant_flag) => {
    let tmp_reactions = [...this.state.reactions];
    let tmp_reactions_times = [...this.state.reactions_times];
    
    //let random_reaction_index = Math.floor(Math.random() * this.reaction_animation_count);
    
    let found_changes = false;
    
    for (let reaction_type of Object.keys(tmp_presentation_reactions)) {
      if (tmp_presentation_reactions[reaction_type][floor_currentTime]) {
        console.log("checkReactions FOUND",floor_currentTime,reaction_type,tmp_presentation_reactions[reaction_type][floor_currentTime]);
        found_changes = true;
        // pick which reactions slot to use
        
        for (let i = 0; i < tmp_presentation_reactions[reaction_type][floor_currentTime]; i++) {
          let reaction_index = null;
          
          if (instant_flag) {
            if (reaction_type === 'clap') {
              reaction_index = 0;
            } else if (reaction_type === 'laugh') {
              reaction_index = 1;
            } else if (reaction_type === 'agree') {
              reaction_index = 2;
            }
          } else {
            for (let i = 0; i < 100; i++) {
              let random_reaction_index = Math.floor(Math.random() * this.reaction_animation_count) + 3;
              if (!tmp_reactions[random_reaction_index]) {
                reaction_index = random_reaction_index;
                break;
              }
            }
          }
          
          if (reaction_index === null) {
            reaction_index = Math.floor(Math.random() * this.reaction_animation_count) + 3;
          }
          
          //tmp_reactions[reaction_index] = `${reaction_type} x ${this.props.presentation_data.reactions[reaction_type][floor_currentTime]}`;
          if (instant_flag) {
            if (this.props.user_avatar_image_url) {
              tmp_reactions[reaction_index] = <React.Fragment><img src={this.reactions_assets[reaction_type]} alt="img" /><br/><img src={this.preloaded_user_avatar_image.src} alt="img" /></React.Fragment>
            } else {
              tmp_reactions[reaction_index] = <React.Fragment><img src={this.reactions_assets[reaction_type]} alt="img" /><br/><img src={gold_star} alt="img" /></React.Fragment>
            }
          } else {
            tmp_reactions[reaction_index] = <img src={this.reactions_assets[reaction_type]} alt="img" />
          }
          tmp_reactions_times[reaction_index] = floor_currentTime;
        }
      }
    }
    
    // now see if we want to clear out old reactions
    tmp_reactions_times.forEach ((tmp_time,index) => {
      if (tmp_time !== null && (tmp_time > floor_currentTime || tmp_time < (floor_currentTime - 1))) {
        tmp_reactions[index] = null;
        tmp_reactions_times[index] = null;
        found_changes = true;
      }
    });
    
    let new_state = {...this.state};
    
    if (found_changes) {
      console.log("checkReactions CHANGES",floor_currentTime,tmp_reactions,tmp_reactions_times);
      new_state.reactions = tmp_reactions;
      new_state.reactions_times = tmp_reactions_times;
      this.setState(new_state);
    }
  }
  
  checkReactions = () => {
    if (!this.video_ref.current || this.video_ref.current.paused) {
      return;
    }
    let floor_currentTime = Math.floor(this.video_ref.current.currentTime);
    
    if (this.props.presentation_reactions) {
      //let tmp_presentation_reactions = JSON.parse(this.props.presentation_reactions);
      
      //this.showReactions(tmp_presentation_reactions,floor_currentTime);
      this.showReactions(this.props.presentation_reactions,floor_currentTime);
    }
  }

  fluidPaused = () => {
    if (!this.video_ref.current) {
      return;
    }
    //console.log("fluidPaused",this.video_ref.current.currentTime,this.video_ref.current.duration);
    
    this.setState({
      reactions: [],
      reactions_times: []
    });
    
    if (this.props.onClickVideoPlayComplete && parseInt(this.video_ref.current.currentTime) === parseInt(this.video_ref.current.duration)) {
      this.props.onClickVideoPlayComplete(true);
    }
  }

  getRemoteVttBlob = async (remote_url) => {
    let extension = remote_url.split('.').pop();
    let xhr = new XMLHttpRequest();

    return new Promise( function(resolve, reject) {
      xhr.open('GET', remote_url, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = function () {
        let arrayBufferView = new Uint8Array(this.response);
        let blob = new window.Blob([arrayBufferView], { type: 'text/vtt' });
        //console.log("GOT BLOB",remote_url,blob);
        resolve(blob);
      };
      xhr.send();
    });
  }

    onAnimateComplete = (index) => {
      console.log("onAnimateComplete",index);
    }

  render() {
    // adjust height for responsive video player
    //let matches600 = useMediaQuery('(min-width:600px)');
    //let matches600 = <MediaQuery minDeviceWidth={600}>Minimum 600</MediaQuery>;
    let height = '438px';
    if (this.state.maxWidth400) {
      height = '260px';
    } else if (this.state.maxWidth575) {
      height = '280px';
    } else if (this.state.maxWidth767) {
      height = '330px';
    } else if (this.state.maxWidth991) {
      height = '400px';
    } else if (this.state.maxWidth1199) {
      height = '375px';
    }
    //  height = '438px';
    //}
    //else if (this.state.)
    
    let white_or_black_class = 'Video-Player-black';
    if (this.props.presentation_data.pad_color) {
      white_or_black_class = 'Video-Player-'+this.props.presentation_data.pad_color;
    }

    let alt_video_sources = [];
    //console.log(" HD",this.props.hd_allowed,this.props.presentation_data.presentation_video_playlist_hd_m3u8_url);
    let video_src_url;
    if (this.props.hd_allowed && this.props.presentation_data.presentation_video_playlist_hd_m3u8_url) {
      video_src_url = this.props.presentation_data.presentation_video_playlist_hd_m3u8_url;
      let video_quality_levels = ['1080','720','480','360'];
      for (let video_quality_level of video_quality_levels) {
        let tmp_array = this.props.presentation_data.presentation_video_playlist_hd_m3u8_url.split('/').slice(0,-1);
        tmp_array.push(video_quality_level+'p.m3u8');
        let alt_url = tmp_array.join('/');
        alt_video_sources.push({url:alt_url,title:video_quality_level+'p'});
      }
    } else {
      if (this.props.presentation_data.presentation_video_playlist_m3u8_url) {
        video_src_url = this.props.presentation_data.presentation_video_playlist_m3u8_url;
        let video_quality_levels = ['720','480','360'];
        for (let video_quality_level of video_quality_levels) {
          let tmp_array = this.props.presentation_data.presentation_video_playlist_m3u8_url.split('/').slice(0,-1);
          tmp_array.push(video_quality_level+'p.m3u8');
          let alt_url = tmp_array.join('/');
          alt_video_sources.push({url:alt_url,title:video_quality_level+'p'});
        }
      }
    }


    
    //const { startMuted,poster_url,url,handleDuration,controls,isPlaying,volume,timeStart } = this.state;
    //console.log("VideoPlayer RENDER",this.state.maxWidth1199,this.state.maxWidth991,this.state.maxWidth767,this.state.maxWidth575,this.state.maxWidth400);
    //console.log("VideoPlayer RENDER",height,isPlaying,this.props.presentation_data);
    
    //console.log("VideoPlayer RENDER",this.props.presentation_data.presentation_video_url);
    return (
      <React.Fragment>

      
      <div style={{ borderStyle: 'solid', borderColor: 'black' }}>
        {/* <div style={{ borderStyle: 'solid' }} className={"pad0 Video-Player "+white_or_black_class}> */}

        {/*
        <span>{this.state.reactions}</span>
        */}

        
        <video
          ref={this.video_ref}
          //style={{ borderStyle: 'solid' }}
          //controls
          //width={'100%'}
          //height={height}
          id={'my-video'+this.props.presentation_data.entity_uuid+this.unixtime_now}
          //id='my-video'
          //crossOrigin="anonymous"
          //playing={true}
        >
          { video_src_url &&
            <React.Fragment>
              <source
                key='auto'
                src={video_src_url}
                type="application/x-mpegURL"
                title='Auto'
              />
              { alt_video_sources.map(item => (
                  <source
                    src={item.url}
                    type="application/x-mpegURL"
                    title={item.title}
                    key={item.title}
                  />
              ))}
            </React.Fragment>
          }
          { !this.props.presentation_data.presentation_video_playlist_m3u8_url &&
            <source
              src={this.props.presentation_data.presentation_video_url}
              type='video/mp4'
            />
          }
  
          { this.props.presentation_data.cc_vtt_local_file_url &&
            <track
              label={this.props.presentation_data.subtitle_title}
              kind="metadata"
              //kind="subtitles"
              srcLang="en"
              //src={this.props.presentation_data.presentation_subtitle_vtt_url}
              src={this.props.presentation_data.cc_vtt_local_file_url}
              //src=""
              //default
            />
          }

        </video>

        
          
            
          { this.state.reactions[0] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 100, width: "200px", height: "50px" }}
                animate={{
                  x: [150,150,75],
                  y: [130,80,0],
                  scale: [1,1,0],
                }}
                transition={{
                  duration: 0.95,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  //times: [0,0.7,1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
                //onAnimationComplete={() => this.onAnimateComplete(0)}
              >
                {this.state.reactions[0]}
              </motion.div>
          }
            
          
          { this.state.reactions[1] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [150,150,75],
                  y: [130,80,0],
                  scale: [1,1,0],
                }}
                transition={{
                  duration: 0.95,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  //times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
                //onAnimationComplete={() => this.onAnimateComplete(1)}
              >
                {this.state.reactions[1]}
              </motion.div>
          }
          { this.state.reactions[2] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [150,150,75],
                  y: [130,80,0],
                  scale: [1,1,0],
                }}
                transition={{
                  duration: 0.95,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  //times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
                //onAnimationComplete={() => this.onAnimateComplete(2)}
              >
                {this.state.reactions[2]}
              </motion.div>
          }
          { this.state.reactions[3] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [-75,-150],
                  y: [180,0],
                  scale: [1, 0],
                }}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
                //onAnimationComplete={() => this.onAnimateComplete(3)}
              >
                {this.state.reactions[3]}
              </motion.div>
          }
          { this.state.reactions[4] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [-50,-125],
                  y: [180,0],
                  scale: [1, 0],
                }}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
                //onAnimationComplete={() => this.onAnimateComplete(4)}
              >
                {this.state.reactions[4]}
              </motion.div>
          }          
          { this.state.reactions[5] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [-25,-100],
                  y: [180,0],
                  scale: [1, 0],
                }}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
                //onAnimationComplete={() => this.onAnimateComplete(5)}
              >
                {this.state.reactions[5]}
              </motion.div>
          }                    
          { this.state.reactions[6] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [0,-75],
                  y: [180,0],
                  scale: [1, 0],
                }}
                //onAnimationComplete={this.onAnimateComplete}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
              >
                {this.state.reactions[6]}
              </motion.div>
          }          
          { this.state.reactions[7] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [25,-50],
                  y: [180,0],
                  scale: [1, 0],
                }}
                //onAnimationComplete={this.onAnimateComplete}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
              >
                {this.state.reactions[7]}
              </motion.div>
          }                 
          { this.state.reactions[8] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [50,-25],
                  y: [180,0],
                  scale: [1, 0],
                }}
                //onAnimationComplete={this.onAnimateComplete}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
              >
                {this.state.reactions[8]}
              </motion.div>
          }
          { this.state.reactions[9] &&
              <motion.div
                style={{ float: 'right', marginTop: "-240px", marginBottom: "190px", zIndex: 1000, width: "200px", height: "50px" }}
                animate={{
                  x: [-100,-175],
                  y: [180,0],
                  scale: [1, 0],
                }}
                //onAnimationComplete={this.onAnimateComplete}
                transition={{
                  duration: 1.9,
                  ease: "easeInOut",
                  //times: [0, 0.2, 0.5, 0.8, 1],
                  times: [0, 1],
                  //loop: Infinity,
                  //repeatDelay: 1
                }}
              >
                {this.state.reactions[9]}
              </motion.div>
          }          
        {/*
        <ReactPlayer
          url={this.props.presentation_data.presentation_video_url}
          controls={true}
          playing
          
        />
        */}
        
        {/*
          <VideoPlayer
            key={this.props.presentation_data.entity_uuid}
            startMuted={startMuted}
            //url={url}
            url={this.props.presentation_data.presentation_video_url}
            //poster_url={poster_url}
            poster_url={this.props.presentation_data.image_url}
            onDuration={handleDuration}
            controls={controls}
            isPlaying={isPlaying}
            volume={volume}
            loop={false}
            markers={this.markers}
            //height={'438px'}
            //height={'100%'}
            height={height}
            width={'100%'}
            timeStart={timeStart}
            onPlay={this.handlePlay}
            onPause={this.handlePause}
            onVolume={this.handleVolume}
            onProgress={this.handleProgress}
            //startFullscreen={true}
          />
        */}
      </div>
      </React.Fragment>
    );
  }
}

export default PlayerVideo;